"use client";

import { Eye } from "lucide-react";

/**
 * Eye glyph — display-only. Wrapping <Link> or <button> owns interactivity.
 *
 * r5 S7: EyeChip no longer renders <button> wrapper.
 * Resolves nested-button hydration error when used inside CandidateCard <Link>.
 */
export const EyeChip: React.FC = () => {
  return <Eye className="size-4" aria-hidden="true" />;
};
